exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board{\n    position: absolute;\n    width: calc(100vh - 10px);\n    height: calc(100vh - 10px);\n    /*max-width: 600px;*/\n    min-width: 120px;\n    /*max-height: 600px;*/\n    min-height: 120px;\n    /*background-image: url('../../assets/images/chess/board.png');\n    background-size: 100% auto;\n    background-repeat: no-repeat;*/\n\n    /*padding: 3.5% 3.7% 3.5% 3.7%;*/\n}\n.board img{\n    position: absolute;\n    z-index: -1;\n    width: 100%;\n    height: 100%;\n}\n\n.pieces-container{\n    width: 89.13%;\n    height: 89.13%;\n    top: 5.43%;\n    right: 5.43%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: wrap;\n        flex-flow: wrap;\n    position: absolute;\n}\napp-pieces{\n    width: 12.5%;\n    height: 12.5%;\n    margin: 0;\n }\napp-pieces:active{\n\tcursor: -webkit-grabbing;\n\tcursor: grabbing;\n}\n\n @media screen and (min-width: 470px) {\n    app-pieces{\n     width: 12.5%;\n     height: 12.5%;\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/board/board.component.css
// module id = ./src/app/board/board.component.css
// module chunks = 1